import { BefGlobalContext, BefMessageServiceContext, BefPageControllerContext } from '@beflam/bef-core';
import { useContext, useEffect, useState } from 'react';
import { AiAssistant } from '../AiAssistant/AiAssistant';
import { AllColleagues } from '../AiColleague/AllColleagues';
import { fetchAIUserList } from '../AiColleague/aiColleagueService';
import { TabManager } from '../tabManager';
import { AgentModeContext } from '../../context/AgentModeContext';
import './agent.scss';
export class AgentProps {
  onOK: any | undefined;
  onDialogChanged: any | undefined;
  onClose: any | undefined;
}

export function Agent(props: AgentProps) {
  const messageService = useContext(BefMessageServiceContext);
  const sGlobal = useContext(BefGlobalContext) as any;
  const [aiUserList, setAiUserList] = useState<any>([]);
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const pageController = useContext(BefPageControllerContext);
  // 创建 TabManager 实例
  const tabManager = new TabManager(pageController);
  const agentModeCtx = useContext(AgentModeContext);

  const getAIUserList = async () => {
    try {
      const list = await fetchAIUserList(sGlobal);
      setAiUserList(list);
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI同事'));
    }
  };
  const openAIPage = (type: string = '', colleague: any = {}) => {
    tabManager.tabCloseAll();
    //这里添加backHandler是为了在AI页面关闭后，能回到当前页继续操作
    agentModeCtx.openAIPage(type, colleague, () => {
      //这里类型为agent，在Content里就会显示当前Agent页面
      agentModeCtx.openAIPage('agent', null);
    });
  };
  const handleAssistantOK = (item: any) => {
    openAIPage('', item);
  };

  const handleColleagueOK = (item: any) => {
    openAIPage('AIUSER', item);
  };

  const handleDialogChanged = (visible: boolean) => {
    setDialogVisible(visible);
    if (props.onDialogChanged) props.onDialogChanged(visible);
  };

  useEffect(() => {
    getAIUserList();
  }, []);

  return (
    <div className="bef-agent-page" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="agent-div">
        <AiAssistant
          onOK={handleAssistantOK}
          onDialogChanged={handleDialogChanged}
          onClose={props.onClose}
        />
      </div>
      <div className="agent-div">
        <AllColleagues
          onOK={handleColleagueOK}
          data={aiUserList}
        />
      </div>
    </div>
  );
}
